/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30Example } from './Oas30Example';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Oas30Example
 * @author eric.wittmann@gmail.com
 */
export class Oas30ExampleDefinition extends Oas30Example implements IDefinition {
    public constructor(name : string) {
        super(name);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.Oas30Example#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitExampleDefinition(this);
    }
}
Oas30ExampleDefinition["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30ExampleDefinition";
Oas30ExampleDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExample","io.apicurio.datamodels.core.models.common.INamed"];




